import { Button, Stack } from "@mui/material";
import { DataGrid, GridColDef, GridRenderCellParams, GridToolbar } from "@mui/x-data-grid";
import React from "react";
import FlexGrid from "../../../components/shared/flexGrid";
import { assessmentFormLanguage } from "../../../rtkquery/types/assessmentFormLanguage";
import { assessmentUsage } from "../../../rtkquery/types/assessmentUsage";
import { useHistory } from "react-router-dom";
import { useLazyGetTemplateQuery } from "../../../rtkquery/apis/assessmentManagementApi";
import { assessmentExport } from "../../../rtkquery/types/assessmentExport";

interface AssessmentContentProps {
    assessmentFormLanguageData: assessmentFormLanguage[] | undefined;
    isLoading: boolean;
    assessmentUsage: assessmentUsage | undefined;
}

export const FormMastersDetail: React.FC<AssessmentContentProps> = (props) => {
	
	const history = useHistory();
  const [fetchingParticipantTemplate, { data: participantTemplate, isFetching: loadingParticipantTemplate, error: participantError }] = useLazyGetTemplateQuery();

	const openBtnClicked = (row: any) => {
		history.push("/assessment-management/" + props.assessmentUsage?.instrumentKey + "/" + row.formMasterKey);
	}

  const exportTemplate = (row: any) => {
    var data: assessmentExport = {
      exportType: "Minimized",
      formMasterKey: row.formMasterKey
    };
    fetchingParticipantTemplate(data).then((res: any) => {
      // download template
      if (res) {
        const template = res.data;
        const blob = new Blob([template], { type: "application/xml" });
        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = row.formMasterName + ".xml";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      }
    })
	}

	const columns: GridColDef[] = [
		{ field: 'formMasterKey', headerName: 'FormMasterKey', width: 120,  minWidth:120 },
		{ field: 'formMasterName', headerName: 'Name', flex: 1 },
		{ field: 'sLanguage', headerName: 'Language', width: 200, minWidth:200 },
    { field: 'cultureName', headerName: 'Culture', width: 200, minWidth:200 },
    {
			field: "exportBtn",
			headerName: " ",
			width: 100,
			renderCell: (params: GridRenderCellParams) => (
				<Button size={"small"} variant={"outlined"} onClick={() => exportTemplate(params.row)}>
					Export
				</Button>
			)
		},
    {
			field: "openBtn",
			headerName: " ",
			width: 100,
			renderCell: (params: GridRenderCellParams) => (
				<Button size={"small"} variant={"outlined"} onClick={() => openBtnClicked(params.row)}>
					Open
				</Button>
			)
		}
	];

  function getRowId(row) {
    return row.formMasterKey;
  }

	return (
    
        <Stack gap={2}>
            <FlexGrid>
              <div
              style={{
                height: '700px',
                width: '100%',
                overflow: 'auto',
              }}
              >
                <DataGrid
                  getRowId={getRowId} 
                  rows={props.assessmentFormLanguageData} columns={columns} 
                  loading={props.isLoading} 
                  slots={{ toolbar: GridToolbar }}
                  />
                </div>
            </FlexGrid>  
        </Stack>
    
        		
	);
};
